import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useCrudForm } from "../common/crudForm/useCrudForm";
import { CrudFormLayout, Field } from "../common/crudForm/crudFormLayout";
import { useAuth } from "../../AuthContext";
import { getProyecto, saveProyecto, getProyectoStatus, getAportesProyecto } from "../../services/proyectosService";
import { personasPromiseOptions, getPersona, getPersonasSelect } from "../../services/personasService";
import { getMonedasSimboloSelect } from "../../services/monedasService";
import { getCotizacion } from "../../services/cotizacionesService.js";
import { getConfig } from "../../config/config.js";
import { dateFormatter } from "../utils/utils.js";
import { formattedToFloat } from "../utils/utils.js";
import moment from "moment";

import Joi from "joi";
import ReactTabHotkeyReplacer from "react-tab-hotkey-replacer/dist/ReactTabHotkeyReplacer";
import ChildArray from "../common/childArray";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Input from "../common/input";
import FileBrowser from "../fileBrowser/fileBrowser";
// import { replaceSeparators } from "../utils/replaceSeparators.js";
import { numberWithCommas } from "../utils/utils.js";

export default function PoyectosForm(props) {
  const history = useHistory();
  const { selectedModule } = useAuth();
  const config = getConfig();

  const serviceFolder = "proyectos";
  const filesUrl = config.filesUrl + "/" + serviceFolder + "/";

  const onCancel = props.onCancel;
  const title = "Proyecto";
  const subTitle = "Detalles";

  const [editingAporte, setEditingAporte] = useState(false);
  const [status, setStatus] = useState(null);
  const [monedas, setMonedas] = useState([]);
  const [modalOpened, setModalOpened] = useState(false);
  const [tipoAporte, setTipoAporte] = useState("A");

  const [dataAporte, setDataAporte] = useState({
    fecha: "",
    moneda: "",
    tipo: "A",
    monto: "0",
    isEditing: false,
    isNew: false,
    nuevo: false,
    cotizacion: 0,
  });

  const initialData = {
    nombre: "",
    ubicacion: "",
    matricula: "",
    partida: "",
    nomenclatura: "",
    notas: "",
    manejaPresupuestos: false,
    archivos: [],
    subproyectos: [],
    titular: { label: "", value: "" },
    socios: [],
    aportes: [],
  };

  const breadcrumbs = [
    {
      title: "Inicio",
      link: "/main",
    },
    {
      title: "Proyectos",
      link: "/proyectos",
    },
    {
      title: "Detalles",
    },
  ];

  const schema = Joi.object({
    nombre: Joi.string().trim().required().messages({
      "string.empty": "Debe ingresar un nombre.",
    }),
    titular: Joi.any()
      .required()
      .custom((value, helpers) => {
        if (!value || !value.label || !value.value) {
          return helpers.error("any.invalid");
        }
        return value;
      })
      .label("Titular")
      .messages({
        "any.required": "Debe ingresar un titular", // undefined
        "any.invalid": "Debe ingresar un titular", // null / empty props
      }),
  });

  const subproyecto = {
    nombre: "",
  };

  const subproyectosFormat = [{ label: "Nombre", width: "50%", column: "nombre", type: "text" }];

  const socio = {
    persona: { value: "", label: "" },
    participacion: 0,
  };

  const sociosFormat = [
    {
      label: "Socio",
      width: "20%",
      column: "persona",
      displayValue: "item.persona.apellido+(item.persona.nombre?', '+item.persona.nombre:'')",
      type: "asyncCreatable",
      options: [],
      promiseOptions: personasPromiseOptions,
      getChild: getPersona,
    },
    {
      label: "Participación",
      width: "10%",
      column: "participacion",
      type: "number",
      showWithCommas: true,
      suffix: "%",
    },
  ];

  const purifyInitialData = (record) => {
    return record;
  };

  const transformBeforeSave = (record) => {
    if (record.aportes) {
      record.aportes.forEach((aporte) => {
        aporte.monto = formattedToFloat(aporte.monto);
        if (aporte.moneda.value) aporte.moneda = aporte.moneda.value;
      });
    }
    record.socios.map((socio) => {
      socio.participacion = formattedToFloat(socio.participacion);
    });
    const transformed = {
      ...record,
      titular: record.titular && record.titular.value != "" ? record.titular.value : "",
    };
    return transformed;
  };

  const transformAfterFetch = (record, aportes, status) => {
    aportes.forEach((aporte) => {
      aporte.fecha = moment.utc(aporte.fecha).format("YYYY-MM-DD");
      aporte.moneda = {
        value: aporte.moneda._id,
        label: aporte.moneda.simbolo,
      };
    });
    setStatus(status);
    const transformed = {
      ...record,
      aportes: aportes,
      titular: record.titular
        ? {
            value: record.titular._id,
            label: record.titular.apellido + " " + record.titular.nombre,
          }
        : { label: "", value: "" },
    };
    return transformed;
  };

  const transformAfterSave = (record) => {
    return record;
  };

  const onSave = async (data) => {
    const savedRecord = await saveProyecto(data);
    return savedRecord;
  };

  const hookFetchData = async (id) => {
    try {
      if (id) {
        const [record, aportes, status, monedas] = await Promise.all([
          getProyecto(id),
          getAportesProyecto(id),
          getProyectoStatus(id),
          getMonedasSimboloSelect(),
        ]);
        setMonedas(monedas);
        return transformAfterFetch(record, aportes, status); // for the transform
      } else {
        const [monedas] = await Promise.all([getMonedasSimboloSelect()]);
        setMonedas(monedas);
        return null;
      }
      // const [condiciones, record] = await Promise.all([getCondicionesIvaSelect(), getPersona(id)]);
      // setCondicionesIva(condiciones); // for the <select>
      // return transFormAfterFetch(record, condiciones); // for the transform
    } catch {
      history.replace("/noconnection");
    }
  };

  const handleExtraAction = () => {
    alert("CAJA");
  };

  const handleNewTitular = () => {
    window.open("/personas/nuevo_", "_blank");
  };

  const handleNewSocio = () => {
    window.open("/personas/nuevo_", "_blank");
  };

  const handleChangeSubproyecto = (array) => {
    // const { data } = this.state;
    crudForm.data.subproyectos = array;
    crudForm.setData({ ...crudForm.data });
  };

  const handleChangeSocio = (array) => {
    // const { data } = this.state;
    crudForm.data.socios = array;
    crudForm.setData({ ...crudForm.data });
  };

  const openDocumentadoModal = (tipo) => {
    setTipoAporte(tipo);
    setModalOpened(true);
  };

  const cancelAporteModal = (index) => {
    const { data } = crudForm;
    if (data.aportes[index].isNew) data.aportes.splice(index, 1);
    crudForm.setData(data);
    setEditingAporte(false);
    setModalOpened(false);
  };

  const addAporteRetiro = (tipo) => {
    if (!editingAporte) {
      openDocumentadoModal(tipo);
      const { data } = crudForm;
      const editingAporte = true;
      const newAporte = {
        fecha: moment.utc().format("YYYY-MM-DD"),
        moneda: "",
        tipo: tipo,
        monto: "0",
        isEditing: true,
        isNew: true,
        nuevo: true,
        cotizacion: 0,
        index: crudForm.data.aportes.length,
      };
      const aportesSocios = [];

      console.log(data.socios);

      data.socios.forEach((socio) => {
        const newApSoc = {
          persona: socio.persona,
          participacion: formattedToFloat(socio.participacion),
        };
        aportesSocios.push(newApSoc);
      });
      newAporte.aportesSocios = aportesSocios;
      if (data.aportes) crudForm.data.aportes.push(newAporte);
      else data.aportes = [newAporte];
      crudForm.setData(data);
      setEditingAporte(editingAporte);
      setDataAporte(newAporte);
    }
  };

  const handleChangeAporte = (e) => {
    const { currentTarget: input } = e;
    const newDataAporte = { ...dataAporte };
    if (input.type === "checkbox") newDataAporte[input.name] = input.checked;
    else newDataAporte[input.name] = input.value;
    setDataAporte(newDataAporte);
  };

  const handleChangeAporteMoneda = (selectedOption, name) => {
    const newDataAporte = { ...dataAporte };
    newDataAporte.moneda = selectedOption;
    setDataAporte(newDataAporte);
  };

  const saveAporte = async (index) => {
    const cotizacion = await getCotizacion();
    const { data } = crudForm;
    const newDataAporte = { ...dataAporte };
    data.aportes[index] = newDataAporte;
    data.aportes[index].monto = formattedToFloat(data.aportes[index].monto);
    data.aportes[index].cotizacion = cotizacion;
    data.aportes[index].isEditing = false;
    data.aportes[index].isNew = false;
    if (!data.aportes[index].totalAportado) data.aportes[index].totalAportado = 0;
    setEditingAporte(false);
    setModalOpened(false);
  };

  const validate = () => {
    const { socios, _id } = crudForm.data;
    if (_id) {
      let total = 0;
      let errors = [];
      socios.forEach((socio) => {
        // if (typeof socio.participacion === "number") total += socio.participacion;
        // else total += parseFloat(replaceSeparators(socio.participacion));
        total += formattedToFloat(socio.participacion);
      });
      if (total !== 100)
        errors.push({
          path: "participaciones",
          message: "El total de las participaciones debe sumar 100%",
        });
      if (errors.length > 0) return errors;
      else return null;
    } else return null;
  };

  const crudForm = useCrudForm({
    defaultPath: "/proyectos",
    initialData,
    validate,
    // hookWillMount,
    purifyInitialData,
    transformBeforeSave,
    twoStepSave: true,
    onSave,
    // onSuccess,
    // Local (client-side) validation still goes through the extension point.
    schema: schema,
    onLoading: props.onLoading,
    onDoneLoading: props.onDoneLoading,
    hookFetchData,

    // (d) => {
    //   const errs = {};
    //   if (!d.make?.trim()) errs.make = "Make is required.";
    //   if (!d.model?.trim()) errs.model = "Model is required.";
    //   return errs;
    // },
    // Normalize data right before it's sent.
    // transformBeforeSave: (d) => ({
    //   ...d,
    //   vin: d.vin?.toUpperCase(),
    //   registeredAt: new Date().toISOString(),
    // }),
    liveValidate: true,
  });

  // --- Overridden submit handler ---
  const handleSubmit = async (e) => {
    e.preventDefault();

    // // 1. Custom pre-processing the base hook doesn't know about.
    // if (crudForm.data.year && Number(crudForm.data.year) > new Date().getFullYear() + 1) {
    //   crudForm.setErrors({ year: "Year can't be in the future." });
    //   return;
    // }

    // 2. Delegate to the base implementation (the "super" call).
    const ok = await crudForm.submit();

    // 3. Custom post-processing, only if the save succeeded.
    if (ok) {
      // console.log("[analytics] car_saved", crudForm.data.make, crudForm.data.model);
      // alert("Car saved!");
    }
  };

  let cantidadAportes = 0;
  let cantidadRetiros = 0;

  return (
    crudForm.data && (
      <CrudFormLayout
        title={title}
        crudForm={crudForm}
        breadcrumbs={breadcrumbs}
        onSubmit={handleSubmit} // note: our override, not crud.handleSubmit
        onCancel={onCancel}
        submitLabel="Guardar"
      >
        <div className="card-header p-0 border-bottom-0 card-tabs">
          <ul className="nav nav-tabs " id="custom-tabs-four-tab" role="tablist">
            <li className="nav-item">
              <a
                className="nav-link active"
                id="general-tab"
                data-toggle="pill"
                href="#general"
                role="tab"
                aria-controls="general"
                aria-selected="true"
              >
                Detalles Del Proyecto
              </a>
            </li>
            {crudForm.data._id && (
              <>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    id="custom-tabs-aportes-tab"
                    data-toggle="pill"
                    href="#custom-aportes-messages"
                    role="tab"
                    aria-controls="custom-tabs-four-messages"
                    aria-selected="false"
                  >
                    Aportes / Retiros
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    id="custom-tabs-estado-tab"
                    data-toggle="pill"
                    href="#custom-estado-messages"
                    role="tab"
                    aria-controls="custom-tabs-four-messages"
                    aria-selected="false"
                  >
                    Estado
                  </a>
                </li>
              </>
            )}
          </ul>
        </div>
        {/* <form onSubmit={this.handleSubmit}> */}
        <ReactTabHotkeyReplacer>
          <div className="card-body">
            <div className="tab-content" id="custom-tabs-four-tabContent">
              <div className="tab-pane fade show active" id="master" role="tabpanel" aria-labelledby="general-tab">
                <div className="card card-primary card-outline card-outline-tabs">
                  <div className="card-body">
                    <div className="tab-content" id="general-tabContent">
                      <div
                        className="tab-pane fade show active"
                        id="general"
                        role="tabpanel"
                        aria-labelledby="general-tab"
                      >
                        <div className="row ">
                          <Field crudForm={crudForm} label="Nombre" name="nombre" float columns="6" autoFocus />
                          <Field
                            crudForm={crudForm}
                            label="Titular"
                            name="titular"
                            columns="6"
                            float
                            asyncCreatable
                            promiseOptions={personasPromiseOptions}
                            onCreateOption={handleNewTitular}
                          />
                        </div>

                        {crudForm.data._id && (
                          <React.Fragment>
                            <div className="row ">
                              <Field crudForm={crudForm} label="Ubicación" name="ubicacion" float columns="12" />
                            </div>
                            <div className="row">
                              <Field crudForm={crudForm} label="Partida" name="partida" float columns="6" />
                              <Field crudForm={crudForm} label="Matrícula" name="matricula" float columns="6" />
                            </div>
                            <div className="row">
                              <Field
                                crudForm={crudForm}
                                label="Nomenclatura Catastral"
                                name="nomenclatura"
                                float
                                columns="12"
                              />
                            </div>
                            <div className="row">
                              <Field
                                crudForm={crudForm}
                                label="Maneja Presupuestos"
                                name="manejaPresupuestos"
                                type="toggle"
                                columns="2"
                              />
                            </div>
                            <div className="row">
                              <ChildArray
                                data={crudForm.data.subproyectos}
                                blankItem={subproyecto}
                                editable={crudForm.action === "C" ? false : true}
                                format={subproyectosFormat}
                                label="Subproyectos"
                                onChange={handleChangeSubproyecto}
                                onIsEditing={(isEditing) => crudForm.handleEditingChildArray(isEditing)}
                              />
                            </div>
                            <div className="row">
                              <ChildArray
                                data={crudForm.data.socios}
                                blankItem={socio}
                                editable={crudForm.action === "C" ? false : true}
                                format={sociosFormat}
                                label="Socios"
                                onChange={handleChangeSocio}
                                onCreateOption={handleNewSocio}
                                onIsEditing={(isEditing) => crudForm.handleEditingChildArray(isEditing)}
                              />
                            </div>
                            <div className="row mt-2">
                              <Field
                                crudForm={crudForm}
                                textarea
                                label="Notas"
                                name="notas"
                                float
                                columns="6"
                                rows="10"
                              />
                              <div className="col-6">
                                <FileBrowser
                                  status={crudForm.action}
                                  recordId={crudForm.data._id}
                                  serviceFolder={serviceFolder}
                                  filesUrl={filesUrl}
                                  canCreateFolder={true}
                                />
                              </div>
                            </div>
                          </React.Fragment>
                        )}
                      </div>

                      <div
                        className="tab-pane fade show"
                        id="custom-aportes-messages"
                        role="tabpanel"
                        aria-labelledby="custom-aportes-messages-tab"
                      >
                        {crudForm.action !== "C" && (
                          <div className="row">
                            <button
                              className="btn btn-secondary buttons-copy buttons-html5 mr-1 "
                              disabled={editingAporte}
                              tabIndex={0}
                              aria-controls="datatable"
                              type="button"
                              onClick={() => addAporteRetiro("A")}
                            >
                              <span>Nuevo Aporte</span>
                            </button>
                            <button
                              className={
                                "btn btn-secondary buttons-copy buttons-html5 " + (editingAporte ? "disabled" : "")
                              }
                              tabIndex={1}
                              aria-controls="datatable"
                              type="button"
                              onClick={() => addAporteRetiro("R")}
                            >
                              <span>Nuevo Retiro</span>
                            </button>
                          </div>
                        )}
                        <table className="mt-5 table table-hover">
                          <tbody>
                            <tr>
                              <th>
                                <div className="row align-items-center">
                                  <div className="col-3">Fecha</div>
                                  <div className="col-3">Aporte/Retiro</div>
                                  <div className="col-2 text-right">Total</div>
                                  <div className="col-2 text-right">Aportado/Retirado</div>
                                  <div className="col-2 text-right">Pendiente</div>
                                </div>
                              </th>
                            </tr>
                            {crudForm.data.aportes &&
                              crudForm.data.aportes.map((aporte, index) => {
                                if (aporte.tipo === "A") cantidadAportes++;
                                if (aporte.tipo === "R") cantidadRetiros++;
                                return !aporte.isNew ? (
                                  <>
                                    <tr
                                      key={Math.random()}
                                      className={aporte.tipo === "A" ? "aporte" : "retiro"}
                                      data-widget="expandable-table"
                                      aria-expanded="false"
                                    >
                                      <td>
                                        <div className="row align-items-center">
                                          <div className="col-3">
                                            <i className="expandable-table-caret fas fa-caret-right fa-fw"></i>
                                            {dateFormatter(aporte.fecha)}
                                          </div>
                                          <div className="col-3">
                                            {aporte.tipo === "A" && <>Aporte # {cantidadAportes}</>}
                                            {aporte.tipo === "R" && <>Retiro # {cantidadRetiros}</>}
                                          </div>
                                          <div className="col-2 text-right">
                                            {aporte.moneda.label + " " + numberWithCommas(aporte.monto)}
                                          </div>
                                          <div className="col-2 text-right">
                                            {aporte.moneda.label + " " + numberWithCommas(aporte.totalAportado)}
                                          </div>
                                          <div
                                            className={
                                              "col-2 text-right" +
                                              (formattedToFloat(aporte.monto - aporte.totalAportado) > 0
                                                ? " font-weight-bold " +
                                                  (aporte.tipo === "A" ? "text-danger" : "text-success")
                                                : "")
                                            }
                                          >
                                            {aporte.moneda.label +
                                              " " +
                                              numberWithCommas(aporte.monto - aporte.totalAportado)}
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                    <tr key={Math.random()} className="expandable-body d-none">
                                      <td>
                                        <div className="p-0">
                                          <table className="table table-hover">
                                            <tbody>
                                              <tr key={Math.random()}>
                                                <th>
                                                  <div className="row align-items-center">
                                                    <div className="col-6">Socio</div>
                                                    <div className="col-2 text-right">
                                                      {aporte.tipo === "A" ? "A Aportar" : "A Retirar"}
                                                    </div>
                                                    <div className="col-2 text-right">
                                                      {aporte.tipo === "A" ? "Aportado" : "Retirado"}
                                                    </div>
                                                    <div className="col-2 text-right">Pendiente</div>
                                                  </div>
                                                </th>
                                              </tr>
                                              {aporte.aportesSocios.map((aporteSocio) => {
                                                if (!aporteSocio.aportado) aporteSocio.aportado = 0;
                                                if (aporteSocio.registros)
                                                  return (
                                                    <>
                                                      <tr
                                                        key={Math.random()}
                                                        data-widget="expandable-table"
                                                        aria-expanded="false"
                                                      >
                                                        <td>
                                                          <div className="row align-items-center">
                                                            <div className="col-6">
                                                              <i className="expandable-table-caret fas fa-caret-right fa-fw"></i>
                                                              {aporteSocio.persona.nombre +
                                                                " " +
                                                                aporteSocio.persona.apellido}
                                                            </div>
                                                            <div className="col-2 text-right">
                                                              {aporte.moneda.label +
                                                                " " +
                                                                numberWithCommas(
                                                                  (aporte.monto * aporteSocio.participacion) / 100,
                                                                )}
                                                            </div>
                                                            <div className="col-2 text-right">
                                                              {aporte.moneda.label +
                                                                " " +
                                                                numberWithCommas(aporteSocio.aportado)}
                                                            </div>
                                                            <div
                                                              className={
                                                                "col-2 text-right" +
                                                                (formattedToFloat(
                                                                  (aporte.monto * aporteSocio.participacion) / 100 -
                                                                    aporteSocio.aportado,
                                                                ) > 0
                                                                  ? " font-weight-bold " +
                                                                    (aporte.tipo === "A"
                                                                      ? "text-danger"
                                                                      : "text-success")
                                                                  : "")
                                                              }
                                                            >
                                                              {aporte.moneda.label +
                                                                " " +
                                                                numberWithCommas(
                                                                  (aporte.monto * aporteSocio.participacion) / 100 -
                                                                    aporteSocio.aportado,
                                                                )}
                                                            </div>
                                                          </div>
                                                        </td>
                                                      </tr>
                                                      <tr key={Math.random()} className="expandable-body d-none">
                                                        <td>
                                                          <div className="p-0">
                                                            <table key={Math.random()} className="table table-hover">
                                                              <tbody>
                                                                {aporteSocio.registros.map((registro) => {
                                                                  return (
                                                                    <>
                                                                      <tr key={Math.random()}>
                                                                        <td>
                                                                          <div className="row">
                                                                            <div className="col-3"></div>
                                                                            <div className="col-9">
                                                                              {dateFormatter(registro.fecha) +
                                                                                " " +
                                                                                registro.moneda +
                                                                                " " +
                                                                                numberWithCommas(registro.aporto) +
                                                                                (registro.aporto !=
                                                                                registro.montoRegistro
                                                                                  ? " (se toman " +
                                                                                    numberWithCommas(registro.aporto) +
                                                                                    " del asiento de " +
                                                                                    numberWithCommas(
                                                                                      registro.montoRegistro,
                                                                                    ) +
                                                                                    " para este aporte)"
                                                                                  : "")}
                                                                            </div>
                                                                          </div>
                                                                        </td>
                                                                      </tr>
                                                                    </>
                                                                  );
                                                                })}
                                                              </tbody>
                                                            </table>
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    </>
                                                  );
                                                else
                                                  return (
                                                    <>
                                                      <tr key={Math.random()}>
                                                        <td>
                                                          <div className="row align-items-center">
                                                            <div className="col-6">
                                                              {aporteSocio.persona.nombre +
                                                                " " +
                                                                aporteSocio.persona.apellido}
                                                            </div>
                                                            <div className="col-2 text-right">
                                                              {aporte.moneda.label +
                                                                " " +
                                                                numberWithCommas(
                                                                  (aporte.monto * aporteSocio.participacion) / 100,
                                                                )}
                                                            </div>
                                                            <div className="col-2 text-right">
                                                              {aporte.moneda.label +
                                                                " " +
                                                                numberWithCommas(aporteSocio.aportado)}
                                                            </div>
                                                            <div
                                                              className={
                                                                "col-2 text-right" +
                                                                (formattedToFloat(
                                                                  (aporte.monto * aporteSocio.participacion) / 100 -
                                                                    aporteSocio.aportado,
                                                                ) > 0
                                                                  ? " font-weight-bold " +
                                                                    (aporte.tipo === "A"
                                                                      ? "text-danger"
                                                                      : "text-success")
                                                                  : "")
                                                              }
                                                            >
                                                              {aporte.moneda.label +
                                                                " " +
                                                                numberWithCommas(
                                                                  (aporte.monto * aporteSocio.participacion) / 100 -
                                                                    aporteSocio.aportado,
                                                                )}
                                                            </div>
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    </>
                                                  );
                                              })}
                                            </tbody>
                                          </table>
                                        </div>
                                      </td>
                                      <td></td>
                                    </tr>
                                  </>
                                ) : (
                                  <></>
                                );
                              })}
                          </tbody>
                        </table>
                      </div>

                      <div
                        className="tab-pane fade show"
                        id="custom-estado-messages"
                        role="tabpanel"
                        aria-labelledby="custom-estado-messages-tab"
                      >
                        {status && (
                          <div className="row">
                            <div className="col-12">
                              <div className="card">
                                <div className="card-body p-0">
                                  <table className="table table-hover">
                                    <tbody>
                                      <tr>
                                        <td colSpan={3}>
                                          <h4>Ingresos</h4>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td style={{ width: "50%" }} className="border-0">
                                          <strong>Aportes</strong>
                                        </td>
                                        <td align="right" style={{ width: "25%" }}>
                                          <strong>Realizados</strong>
                                        </td>
                                        <td align="right" style={{ width: "25%" }}>
                                          <strong>Pendientes</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td></td>
                                        <td align="right">u$s {numberWithCommas(status.aportesRealizados)}</td>
                                        <td align="right">
                                          u$s {numberWithCommas(status.totalAportes - status.aportesRealizados)}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td colSpan={3}>
                                          <h4>Egresos</h4>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td style={{ width: "50%" }} className="border-0">
                                          <strong>Presupuestos</strong>
                                        </td>
                                        <td align="right" style={{ width: "25%" }}>
                                          <strong>Abonado</strong>
                                        </td>
                                        <td align="right" style={{ width: "25%" }}>
                                          <strong>Pendiente</strong>
                                        </td>
                                      </tr>
                                      {status.presupuestos.map((presupuesto) => (
                                        <>
                                          <tr key={Math.random()}>
                                            <td>{presupuesto.descripcion}</td>
                                            <td align="right">
                                              u$s{" "}
                                              {numberWithCommas(
                                                presupuesto.pagosindocumentar + presupuesto.pagodocumentado,
                                              )}
                                            </td>
                                            <td align="right">
                                              u$s{" "}
                                              {numberWithCommas(
                                                presupuesto.total -
                                                  presupuesto.pagosindocumentar -
                                                  presupuesto.pagodocumentado,
                                              )}
                                            </td>
                                          </tr>
                                        </>
                                      ))}
                                      <tr>
                                        <td style={{ width: "50%" }} className="border-0">
                                          <strong>Categorias</strong>
                                        </td>
                                        <td align="right" style={{ width: "25%" }}>
                                          <strong>Egreso</strong>
                                        </td>
                                        <td align="right" style={{ width: "25%" }}>
                                          <strong>Ingreso</strong>
                                        </td>
                                      </tr>
                                      {status.categorias.map((categoria) => (
                                        <>
                                          {categoria.rubros.map((rubro) => (
                                            <>
                                              <tr key={Math.random()}>
                                                <td>
                                                  {categoria.categoria} - {rubro.rubro}
                                                </td>
                                                <td align="right">u$s {numberWithCommas(rubro.egresos)}</td>
                                                <td align="right">u$s {numberWithCommas(rubro.ingresos)}</td>
                                              </tr>
                                            </>
                                          ))}
                                        </>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ReactTabHotkeyReplacer>
        {/* </form> */}

        <Modal show={modalOpened}>
          <Modal.Header className={tipoAporte === "A" ? "aporte" : "retiro"}>
            <Modal.Title className="text-white">
              <strong>{tipoAporte === "A" ? "Aporte" : "Retiro"}</strong>
            </Modal.Title>
            <button type="button" className="close" onClick={() => cancelAporteModal(dataAporte.index)}>
              <span aria-hidden="true">×</span>
              <span className="sr-only">Cerrar</span>
            </button>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Input
                date
                autoFocus
                float
                columns="4"
                label="Fecha"
                name="fecha"
                value={dataAporte.fecha}
                onChange={(event) => handleChangeAporte(event)}
              />
              <Input
                combo
                float
                columns="4"
                label="Moneda"
                name="moneda"
                value={dataAporte.moneda}
                options={monedas}
                onChange={(event, name) => handleChangeAporteMoneda(event, name)}
              />
            </Row>
            <Row>
              <Input
                number
                float
                columns="10"
                label="Monto"
                name="monto"
                value={dataAporte.monto}
                onChange={(event) => handleChangeAporte(event)}
              />
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => cancelAporteModal(dataAporte.index)}>
              Cerrar
            </Button>
            <Button
              variant="secondary"
              disabled={dataAporte.monto <= 0 || !dataAporte.moneda || !dataAporte.fecha}
              onClick={() => saveAporte(dataAporte.index)}
            >
              Guardar
            </Button>
          </Modal.Footer>
        </Modal>
      </CrudFormLayout>
    )
  );
}
